module.exports = __webpack_public_path__ + "static/img/150_TO8_1865.985e86c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/150_TO8_1865.jpg
// module id = nruP
// module chunks = 0